import { encodeParams, digObject } from '@domain-group/javascript-utils'

export async function geocodeAddress(address: string) {
  const options = {
    address,
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?${encodeParams(options)}`

  const response = await fetch(url)
    .then(data => data.json())
    .catch((error) => {
      console.error(error.message)
    })

  // Status errors
  if (response.status !== 'OK' && response.status !== 'ZERO_RESULTS'){
    return { success: false as const, errors: [`An error has occurred: ${response.status}`] }
  }

  if (response.status === 'ZERO_RESULTS'){
    return { success: false as const, errors: ['No address found'] }
  }

  const resultsArray = response.results

  if (resultsArray.length > 1){
    return { success: false as const, errors: ['Multiple addresses found'] }
  }

  const result = resultsArray[0]
  const location = digObject(result, 'geometry.location', {})

  return { success: true as const, location }
}

export default geocodeAddress
